import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useListAndSearchAllAccounts } from "@rentablo/api/apiv1";
import { AccountEditCard } from "./AccountEditCard";
import { ContraAccountRow } from "./AdditionalContraAccounts/ContraAccountRow";

interface LinkedDepotsCardProps {
  accountId: number;
}

export const LinkedDepotsCard = ({ accountId }: LinkedDepotsCardProps) => {
  const { t } = useTranslation();

  const { data: accountList } = useListAndSearchAllAccounts();
  const accounts = accountList?.accounts ?? [];
  const account = accounts.find((item) => item.id === accountId);

  const depots = (account?.depotIds ?? [])
    .map((id) => accounts.find((item) => item.id === id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  if (!depots.length) return null;

  return (
    <AccountEditCard
      title={t("createAndEditAccount.linkedDepots.title")}
      description={t("createAndEditAccount.linkedDepots.description")}
      testId="linked-depots-card"
    >
      <Box display="flex" flexDirection="column" gap={4}>
        {depots.map((depot) => (
          <ContraAccountRow
            key={depot.id}
            accountName={depot.name}
            iban={depot.iban}
            bankImage={depot.iconUrl}
            accountType="01_depot"
            to={`/depots/${depot.id}`}
          />
        ))}
      </Box>
    </AccountEditCard>
  );
};
